import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import _ from 'lodash';
import { UserRole } from '../../shared/constants/user-role';
import { ISelectList } from '../../shared/models/select-list.model';
import { IPermissionsModel, IUserModel } from '../../shared/models/user-model';
import { AuthConsoleApiService } from '../../shared/services/auth-console-api/auth-console-api.service';
import { BusinessService } from '../../shared/services/business/business.service';
import { MessageService } from '../../shared/services/message/message.service';
import { UserService } from '../../shared/services/user/user.service';
import { GatekeeperModalComponent } from '../modal.component';

@Component({
  selector: 'gk-add-user-modal',
  templateUrl: './add-user-modal.html'
})
export class AddUserModalComponent
  extends GatekeeperModalComponent<AddUserModalComponent>
  implements OnInit
{
  user = <IUserModel>{};
  roleList: Array<ISelectList> = [];
  businessList: Array<ISelectList> = [];

  constructor(
    private messageService: MessageService,
    private authConsoleApiService: AuthConsoleApiService,
    private businessService: BusinessService,
    private userService: UserService,
    public dialogRef: MatDialogRef<AddUserModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
  }
  ngOnInit(): void {
    this.businessService.businessSummaries$.subscribe(x => {
      this.businessList = _.map(x, y => ({ id: y.id, value: y.name }));
    });
    this.roleList = this.authConsoleApiService.getUserRoleList(UserRole.Admin);

    this.user.id = -1;
    this.user.isActive = true;
    this.user.isAdmin = false;
    this.user.authId = '';
    this.user.licenceExpiryDate = new Date();
    this.user.licenceIsActive = true;
    this.user.accountId = this.userService.user.accountId ?? 1;
    this.user.organisationName = this.userService.user.organisationName;
    this.user.organisationIdentifier =
      this.userService.user.organisationIdentifier;
    this.user.firstName = '';
    this.user.lastName = '';
    this.user.emailAddress = '';
    this.user.licencedSku = 'PR-GKO';
    this.user.permissions = this.businessList.map(
      b =>
        <IPermissionsModel>{
          businessId: b.id,
          businessName: b.value,
          businessAccess: false,
          fullAccess: false,
          editCrop: false,
          priceOnly: false
        }
    );
  }

  saveUser() {
    this.authConsoleApiService
      .createUser(this.user)
      .then(response => {
        this.messageService.showIcon(MessageTypeEnum.Success);
        this.dialogRef.close({ addAnother: false, id: response[0] });
      })
      .catch(() => {
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          'USER_SAVE_ERROR'
        );
        this.close();
      });
  }

  close = () => {
    this.dialogRef.close(false);
  };
}
